import styled from 'styled-components';
import BaseStep from '../Step';

export const Step = styled(BaseStep)`
  width: 100%;
`;

export const InfoBubble = styled.div`
  background-color: #f8f8f8;
  border-radius: 16px;
  font-size: 16px;
  padding: 8px 16px;
  width: fit-content;
  margin-bottom: 10px;
`;

InfoBubble.Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const LoadingProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  gap: 12px;
  align-items: center;
`;

InfoBubble.Text = styled.p`
  margin: 0;
  color: #9b9b9b;
  font-size: 13px;
  line-height: 1.5;
  flex: 1;
`;

InfoBubble.CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e9ecef;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px
  gap: 16px;
`;

ControlsContainer.Left = styled.div`
  display: flex;
  align-items: top;
  gap: 8px;
`;

ControlsContainer.Right = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

ControlsContainer.Checkbox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 12px;

  input[type='checkbox'] {
    margin: 0;
  }

  label {
    font-size: 14px;
    color: #495057;
    cursor: pointer;
    margin: 0;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 300px;
`;

SearchContainer.Icon = styled.div`
  position: absolute;
  left: 12px;
  top: 8px;
  color: #1f1f1f;
  z-index: 1;

  svg {
    width: 24px;
    height: 24px;
  }
`;

SearchContainer.Input = styled.input`
  width: 100%;
  padding: 8px 16px 8px 40px;
  border: 1px solid #dbdbdb;
  border-radius: 13px;
  font-size: 16px;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &::placeholder {
    color: #6c757d;
  }
`;

export const CalendarContainer = styled.div`
  background: white;
`;

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

DateContainer.ArrowButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #495057;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: #e9ecef;
    color: #007bff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

DateContainer.MonthTitle = styled.span`
  font-size: 18px;
  font-weight: 500;
  color: #212121;
  text-align: center;
  width: 150px;
`;

CalendarContainer.Days = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #dddddd;
  margin-bottom: 8px;
`;

export const DayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

DayContainer.Empty = styled.div`
  display: grid;
  grid-template-columns: 64px 1fr;
  align-items: center;
  padding: 6px 0;
`;

DayContainer.EmptyLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

DayContainer.EmptyRight = styled.div`
  display: flex;
  align-items: center;
`;

DayContainer.Left = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 20px;
`;

DayContainer.EmptyDayNumber = styled.div`
  width: 55px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: ${props => (props.isToday ? '#004BC4' : '#b4b4b4')};
`;

DayContainer.DayNumber = styled.div`
  width: 45px;
  height: 45px;
  display: flex;
  margin: -10px 12px 0 12px;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 24px;
  color: ${props => (props.isToday ? '#004BC4' : '#212121')};
  background-color: ${props => (props.isToday ? '#f8f8f8' : '#fff')};
  border-radius: 50%;
`;

DayContainer.Right = styled.div`
  padding: 8px 0;
  width: 100%;
  ${props => (props.hasDeliveries ? '' : 'display: flex; align-items: center;')}
`;

DayContainer.EmptyLine = styled.div`
  width: 97%;
  height: 1px;
  background: #e0e0e0;
`;

DayContainer.Card = styled.div`
  border: ${props =>
    props.isToday ? '2px solid #004BC4' : '1px solid #dbdbdb'};
  display: flex;
  flex-direction: row;
  border-radius: 13px;
  overflow: hidden;
  background: #fff;
  margin: 4px 8px 8px 8px;
`;

export const DeliveryRow = styled.div`
  display: grid;
  grid-template-columns: 15% 30% 15% 40%;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f6f7f8;
  align-items: start;
  min-height: 40px;

  &:last-child {
    border-bottom: none;
  }
`;

DeliveryRow.ContactName = styled.div`
  color: #212121;
  font-size: 16px;
`;

DeliveryRow.ContactEmail = styled.div`
  color: #212121;
  font-size: 16px;
`;

DeliveryRow.StageName = styled.div`
  color: #212121;
  font-size: 16px;
`;

DeliveryRow.Subject = styled.div`
  color: #212121;
  font-size: 16px;
  max-width: 90%;
  overflow-wrap: break-word;
`;

DeliveryRow.EmptyText = styled.div`
  color: #6c757d;
  font-style: italic;
  font-size: 14px;
`;

DeliveryRow.ShowMore = styled.div`
  font-size: 14px;
  color: #9b9b9b;
  text-decoration: underline;
  cursor: pointer;
`;

export const InfoContainer = styled.span`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

export const Container = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;

export const Title = styled.span`
  color: #212121;
  font-family: Poppins;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
`;

export const Description = styled.div`
  color: #9b9b9b;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 10px;
`;
